"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Message_1 = __importDefault(require("../message/Message"));
const RedeemConfigStore_1 = __importDefault(require("../../stores/RedeemConfigStore"));
const common_1 = require("@epic-core/common");
const epic_react_common_1 = require("epic-react-common");
exports.default = epic_react_common_1.ErrorMessage(RedeemConfigStore_1.default, common_1.getLocale, Message_1.default);
//# sourceMappingURL=ErrorMessageComponent.js.map